import { render, staticRenderFns } from "./Proyectos.vue?vue&type=template&id=cb6a9066&"
import script from "./Proyectos.vue?vue&type=script&lang=js&"
export * from "./Proyectos.vue?vue&type=script&lang=js&"
import style0 from "./Proyectos.vue?vue&type=style&index=0&id=cb6a9066&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports